"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("../Button");
var react_dropzone_1 = require("react-dropzone");
var AcceptedFileTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/pdf',
    'application/vnd.ms-excel',
    'application/xls',
    'application/excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'text/csv',
    'text/plain',
].join(',');
var Dropzone = /** @class */ (function (_super) {
    __extends(Dropzone, _super);
    function Dropzone() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initReactDropzone = function (dz) {
            _this.dz = dz;
        };
        _this.onUploadClicked = function () {
            _this.dz.open();
        };
        return _this;
    }
    Dropzone.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_dropzone_1.default, { onDrop: this.props.onDrop, accept: AcceptedFileTypes, multiple: false, ref: this.initReactDropzone }, function (_a) {
            var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps;
            return (React.createElement("div", __assign({}, getRootProps(), { onClick: _this.onUploadClicked }),
                React.createElement("input", __assign({}, getInputProps())),
                _this.props.children || (React.createElement(Button_1.Button, { variant: "primary", onClick: _this.onUploadClicked }, "Upload"))));
        }));
    };
    return Dropzone;
}(React.Component));
exports.default = Dropzone;
//# sourceMappingURL=index.js.map